import { gql } from '@apollo/client'

import { getQueryService } from '../../../../helpers/GraphqlHelpers'

export const familyRelationships = getQueryService({
  query: gql`
    query familyRelationships {
      familyRelationships {
        id
        name
        active
        order
      }
    }
  `,
  transformer: (response) => {
    return response
  },
})
